import React from 'react';
import PropTypes from 'prop-types';
import ContentLibraryAssetCard from './ContentLibraryAssetCard';

export default function ContentLibraryAssetGrid({
  assets,
  selectedAsset,
  onSelectAsset
}) {
  if (assets.length === 0) {
    return (
      <p className='px-2 py-8 text-center text-sm text-gray-500'>
        No content matches your filters.
      </p>
    );
  }

  return (
    <ul className='grid list-none grid-cols-2 gap-4 p-0 sm:grid-cols-3 2xl:grid-cols-5'>
      {assets.map(asset => (
        <ContentLibraryAssetCard
          key={String(asset.id)}
          asset={asset}
          selected={selectedAsset?.id === asset.id}
          onSelect={() => onSelectAsset(asset)}
        />
      ))}
    </ul>
  );
}

ContentLibraryAssetGrid.propTypes = {
  assets: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedAsset: PropTypes.object,
  onSelectAsset: PropTypes.func.isRequired
};

ContentLibraryAssetGrid.defaultProps = {
  selectedAsset: null
};
